import React, { Component } from 'react';
import { FileUpload } from 'primereact/fileupload';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FaTimesCircle } from 'react-icons/fa';
import { Dialog as DialogPrime } from 'primereact/dialog';
import { Button as ButtonPrime } from 'primereact/button';
import { dominioDemandaCirurgica } from '../../config/database';
import 'assets/css/documentos.css';
import 'assets/css/geral.css';

class Documentos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listaDocumentos: [],
      loading: false,
      pedidoCirurgia: null,
      mensagemErroTamanho: false,
    };
  }

  listarDocumentos = () => {
    this.setState({ loading: true });
    const pedidoCirurgia = JSON.parse(localStorage.getItem('pedidoCirurgia'));
    if (pedidoCirurgia) {
      this.setState({ pedidoCirurgia });

      dominioDemandaCirurgica.get(`/api/documento/${pedidoCirurgia.id}`).then(
        res => {
          this.setState({ listaDocumentos: res.data, loading: false });
        },
        () => {
          this.setState({ loading: false });
        }
      );
    }
  };

  componentDidMount() {
    this.listarDocumentos();
  }

  onSelect = e => {
    if (e.files[0].size > 5000000) {
      this.setState({ mensagemErroTamanho: true });
      return;
    }

    const dataDocumento = new FormData();

    dataDocumento.append('arquivo', e.files[0], e.files[0].name);
    dataDocumento.append('pedidoCirurgia', this.state.pedidoCirurgia.id);

    dominioDemandaCirurgica.post(`/api/documento`, dataDocumento).then(res => {
      const lista = [...this.state.listaDocumentos, res.data];
      this.setState({ listaDocumentos: lista });
    });
  };

  onClear = () => {
    const content = document.getElementById('content');
    content.innerHTML = '';
  };

  getSplitNomeDocumento = nome => {
    const nomeSplit = nome.split('/');
    return nomeSplit[nomeSplit.length - 1];
  };

  handleExcluirDocumento = id => {
    dominioDemandaCirurgica.delete(`/api/documentodetail/${id}`).then(() => {
      this.listarDocumentos();
    });
  };

  renderFooterDisplay = () => {
    return (
      <div>
        <ButtonPrime
          label="OK"
          icon="pi pi-check"
          onClick={() => this.setState({ mensagemErroTamanho: false })}
          autoFocus
        />
      </div>
    );
  };

  render() {
    if (this.state.loading) {
      return (
        <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
          <ProgressSpinner />
        </div>
      );
    }

    return (
      <div>
        <DialogPrime
          header="Atenção!"
          visible={this.state.mensagemErroTamanho}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ mensagemErroTamanho: false })}
          footer={this.renderFooterDisplay()}
        >
          <div>
            <p>Tamanho de arquivo excedeu o tamanho máximo (5MB)</p>
          </div>
        </DialogPrime>
        <div className="card">
          <FileUpload
            className="esconder-botoes-upload-cancelar"
            name="demo[]"
            onSelect={this.onSelect}
            onClear={this.onClear}
            multiple
            previewWidth={10}
            chooseLabel="Escolher"
            cancelLabel="Cancelar"
          />
        </div>
        <div id="content" className="div-content">
          {this.state.listaDocumentos.map(item => {
            return (
              <div key={item.id} style={{ width: '100%', marginBottom: '5px' }}>
                <span>{this.getSplitNomeDocumento(item.arquivo)}</span>
                <span>
                  <button
                    type="button"
                    className="botao-excluir-documento"
                    onClick={() => this.handleExcluirDocumento(item.id)}
                  >
                    <FaTimesCircle color="black" size={20} />
                  </button>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default Documentos;
